import * as React from "react";
const SvgDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 12, viewBox: "0 0 17 12", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.5 11.5.5.5h16z", fill: "#FFF", fillRule: "evenodd" }));
export default SvgDown;
